'use strict';

/**
 * Init All Widget Logic
 */
class TWER_WIDGETS {

  /**
   * Widgets constructor
   *
   * @param props
   */
  constructor(props) {
    // Init JQuery
    this.$ = $ = props;

    // Init core constants/variables etc
    this.$widgets = $([
      '#treweler-widgets-top-left',
      '#treweler-widgets-middle-left',
      '#treweler-widgets-bottom-left',
      '#treweler-widgets-top-right',
      '#treweler-widgets-middle-right',
      '#treweler-widgets-bottom-right',
    ].join(', '));

    const $widgets_area = document.querySelectorAll('.js-twer-widgets');

    // Init JQ UI sortable
    this.initSortable();


    // Add dynamic events for inner widget elements
    $widgets_area.forEach((element) => {

      element.addEventListener('click', event => {

        // Close/Open widget after click
        this.toggleWidget(event);

        // Click Add Widget button handler
        this.addWidget(event);

        // Click Remove Widget button handler
        this.removeWidget(event);
      });

      element.addEventListener('keyup', event => {
        // Change widget header after keyup handler on "value" input
        this.updateHeadWidget(event);
      });

    });

  }

  /**
   * Init sortable method
   */
  initSortable() {
    this.$widgets.sortable({
      connectWith: '.js-twer-ui-repeater',
      handle: '.js-twer-widget-ui-handle',
      cursor: 'move',
      receive: (event, ui) => this.updateAlienWidget(event, ui)
    }).disableSelection();
  }

  /**
   * Update widget head method
   *
   * @param event
   */
  updateHeadWidget(event) {
    const target = event.target;
    if (target.classList.contains('js-twer-dynamic-description')) {
      const $titleWidget = target.closest('.js-twer-widget').getElementsByClassName('js-twer-title-widget')[0];

      if (target.value) {
        $titleWidget.innerText = target.value;
      } else {
        $titleWidget.innerHTML = '&nbsp;';
      }
    }
  }

  /**
   * Update alien widget after move from another list
   *
   * @param event
   * @param ui
   */
  updateAlienWidget(event, ui) {
    const $currentItem = ui.item[0];
    const $previousItem = ui.sender[0];
    const $repeater = $currentItem.parentNode;

    const currentPosition = $repeater.dataset.position;
    const previousPosition = $previousItem.dataset.position;
    const newIndex = $repeater.childElementCount.toString();

    let currentItemHtml = $currentItem.innerHTML;

    const regex_name = new RegExp(`${previousPosition}`, 'mg');
    const regex_id = new RegExp(`${previousPosition.replace('_', '-')}`, 'mg');

    currentItemHtml = currentItemHtml.replace(regex_name, currentPosition);
    currentItemHtml = currentItemHtml.replace(regex_id, currentPosition.replace('_', '-'));
    currentItemHtml = currentItemHtml.replace(/\]\[\d+\]\[/gm, `][${newIndex}][`);
    currentItemHtml = currentItemHtml.replace(/-\d+-/gm, `-${newIndex}-`);

    $currentItem.innerHTML = currentItemHtml;

    this.updateSortable();
  }

  /**
   * Update sortable elements after some actions
   */
  updateSortable() {
    this.$widgets.sortable('refresh');
    this.$widgets.sortable('refreshPositions');
  }

  /**
   * Remove widget method
   *
   * @param event
   */
  removeWidget(event) {
    if (event.target.classList.contains('js-twer-remove-widget')) {
      event.preventDefault();
      event.target.closest('.js-twer-widget').remove();

      this.updateSortable();
    }
  }

  /**
   * Toggle widget method
   *
   * @param event
   */
  toggleWidget(event) {
    const $widgetHandle = event.target.closest('.js-twer-widget-handle');
    if (!!$widgetHandle) {
      event.preventDefault();
      $widgetHandle.closest('.js-twer-widget').classList.toggle('open');
    }

  }

  /**
   * Add widget method
   *
   * @param event
   */
  addWidget(event) {
    if (event.target.classList.contains('js-twer-add-widget')) {
      event.preventDefault();
      const $widget = event.target.closest('.js-twer-widget');
      const $template = $widget.getElementsByClassName('js-twer-repeater-template')[0];
      const $repeater = $widget.getElementsByClassName('js-twer-repeater')[0];
      const range = document.createRange();

      let templateHtml = $template.innerHTML;
      templateHtml = templateHtml.replace(/data-/mg, '');
      templateHtml = templateHtml.replace(/%index%/mg, $repeater.childElementCount.toString());

      const documentFragment = range.createContextualFragment(templateHtml);
      $repeater.appendChild(documentFragment);
      event.target.blur();

      this.updateSortable();
    }
  }

}

export default TWER_WIDGETS;

